class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector(".moonbase-header");
    this.headerIsAlwaysSticky =
      this.getAttribute("data-sticky-type") === "always" ||
      this.getAttribute("data-sticky-type") === "reduce-logo-size";
    this.headerBounds = {};

    this.menuTopLevelItems = this.header.querySelectorAll(
      ".header__desktop-menu-item"
    );

    this.menuTopLevelItems.forEach((item) => {
      item.addEventListener("mouseenter", this.onHover.bind(this));
      item.addEventListener("mouseleave", this.onHoverOut.bind(this));
    });

    this.setHeaderHeight();

    window
      .matchMedia("(max-width: 990px)")
      .addEventListener("change", this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add("shopify-section-header-sticky");
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector("predictive-search");

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);

    this.createObserver();
  }

  onHover(event) {
    const e = event;
    const megaMenu = e.target.querySelector(".mega-menu");
    if (megaMenu) {
      this.hoverTimeout = setTimeout(() => {
        megaMenu.open = true;
      }, 300);
    }
  }

  onHoverOut(event) {
    const e = event;
    const megaMenu = e.target.querySelector(".mega-menu");
    if (megaMenu) {
      clearTimeout(this.hoverTimeout);
      megaMenu.open = false;
    }
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  setHeaderHeight() {
    const announcementBar = document.querySelector(
      ".moonbase-announcement-bar"
    );
    let headerHeight = this.header.offsetHeight;

    if (announcementBar && this.isInViewport(announcementBar)) {
      headerHeight += announcementBar.offsetHeight;
    } else {
      headerHeight = this.header.offsetHeight;
    }

    document.documentElement.style.setProperty(
      "--header-height",
      `${headerHeight}px`
    );
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add("scrolled-past-header");
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.setHeaderHeight();
      this.header.classList.add("scrolled-past-header");
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.setHeaderHeight();
      this.header.classList.remove("scrolled-past-header");
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky"
    );
    this.closeMenuDisclosure();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add("shopify-section-header-sticky", "animate");
    this.header.classList.remove("shopify-section-header-hidden");
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate"
    );
  }

  closeMenuDisclosure() {
    this.details = this.details || this.header.querySelectorAll("details");
    this.details.forEach((detail) => detail.removeAttribute("open"));
  }
}

const showButton = document.getElementById("showDialog");
const favDialog = document.getElementById("header__search-modal");

if (favDialog) {
  const confirmBtn = favDialog.querySelector("#confirmBtn");

  // "Show the dialog" button opens the <dialog> modally
  showButton.addEventListener("click", () => {
    favDialog.showModal();
  });

  // If the user clicks while the dialog is open
  // If they click outside of the form area, close the modal
  // If they click on the submit button, leave the modal open
  favDialog?.addEventListener("click", (e) => {
    if (e.target === favDialog) {
      favDialog.close();
    }
  });

  // Prevent the "confirm" button from the default behavior of submitting the form, and close the dialog with the `close()` method, which triggers the "close" event.
  confirmBtn?.addEventListener("click", (event) => {
    event.preventDefault(); // We don't want to submit this fake form
  });
}

customElements.define("sticky-header", StickyHeader);

/*** Search ***/

/* Desktop Search Overlay */
const openSearch = document.getElementById("js-open-search-overlay");
const headerSearchOverlay = document.getElementById("js-header__search-overlay");

openSearch.addEventListener("click", () => {
  headerSearchOverlay.classList.add('active');
  document.documentElement.classList.add("overlay--open");

  const searchInput = document.querySelector("#js-header__search-overlay .js-search-input");
  if (searchInput) {
    searchInput.focus();
  }
});

// Close the search via button that can only be tabbed to
const closeSearch = document.getElementById("js-close-search-overlay");
const predictiveSearchResults = document.querySelector('.predictive-search__results');

closeSearch.addEventListener("click", () => {
  document.documentElement.classList.remove("overlay--open");
  headerSearchOverlay.classList.remove('active');
  document.documentElement.classList.remove("predictive-search-open");
  document.querySelector('.header__search-overlay .js-search-input').value = '';
  predictiveSearchResults.classList.remove('block');
  predictiveSearchResults.classList.add('hidden');
});

// Close the search overlay when the user moves away from the "search-form" on desktop only
const searchFormDesktop = document.querySelector(".search-form--desktop");
if (searchFormDesktop) {
  searchFormDesktop.addEventListener("mouseleave", () => {
      document.documentElement.classList.remove("overlay--open");
      headerSearchOverlay.classList.remove('active');
      document.documentElement.classList.remove("predictive-search-open");
      document.querySelector('.header__search-overlay .js-search-input').value = '';
      predictiveSearchResults.classList.remove('block');
      predictiveSearchResults.classList.add('hidden');
  });
}

/* Mobile Search Overlay (within mobile nav drawer) */
const mobileSearchField = document.querySelector('.side-drawer__search .js-search-input');
const mobileSearchPopular = document.querySelector('.side-drawer__search .popular-searches');
const mobileDrawerNav = document.querySelector('.side-drawer__navigation');

mobileSearchField.addEventListener("click", () => {
  mobileSearchPopular.classList.replace('hidden', 'block');
  mobileDrawerNav.classList.add('hidden');
});

/* Reset search when closing mobile drawer */
const closeMobileDrawer = document.querySelector('.js-mobile-nav-drawer summary');
const mobilePredictiveSearchResults = document.querySelector('.js-mobile-nav-drawer .predictive-search__results');

if (closeMobileDrawer) {
closeMobileDrawer.addEventListener("click", () => {
  mobileSearchPopular.classList.replace('block', 'hidden');
  mobileDrawerNav.classList.remove('hidden');
  predictiveSearchResults.classList.add('hidden');
  document.querySelector('.side-drawer__search .js-search-input').value = '';
});
}


// Price toggle
document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById('price-toggle');
  const savedState = sessionStorage.getItem('hidePrices');

  // Set checkbox state based on session
  const shouldHidePrices = savedState !== 'false'; // default to checked (true)
  checkbox.checked = shouldHidePrices;
  document.body.classList.toggle('hide-prices', shouldHidePrices);

  // Re-enable transitions after a moment
  setTimeout(() => {
    document.body.classList.remove('price-toggle-update');
  }, 0);

  // Save state on change
  checkbox.addEventListener('change', (e) => {
    const isChecked = e.target.checked;
    document.body.classList.toggle('hide-prices', isChecked);
    sessionStorage.setItem('hidePrices', isChecked ? 'true' : 'false');
  });
});